import { TypeVideoEmbedEnum } from '../models/api/enums/TypeVideoEmbedEnum';

export const getEmbedVideoUrl = (id: string, typeVideoEmbedEnum: TypeVideoEmbedEnum): string => {
  switch (typeVideoEmbedEnum) {
    case TypeVideoEmbedEnum.YOUTUBE:
      return 'https://www.youtube.com/embed/' + id + '?wmode=transparent&showinfo=0&autohide=1';
    case TypeVideoEmbedEnum.VIMEO:
      return 'https://player.vimeo.com/video/' + id + '?title=0&byline=0&portrait=0&color=8ab818';
    case TypeVideoEmbedEnum.DAILYMOTION:
      return 'https://www.dailymotion.com/embed/video/' + id;
    case TypeVideoEmbedEnum.SLIDESHARE:
      return 'https://www.slideshare.net/slideshow/embed_code/' + id + '?wmode=transparent';
    case TypeVideoEmbedEnum.BITTUBE:
      return 'https://bit.tube/playerembed/' + id;
  }
};
